import { types } from './Checkout.actions';

export const initCheckoutState = ({
  adyen_client_pubkey: adyenClientPubkey,
  analytics_data: analyticsData,
  checkout_error: checkoutError,
  checkout_submitting: checkoutSubmitting,
  checkout_success: checkoutSuccess,
  checkout_success_redirect_path: checkoutSuccessRedirectPath,
  currency,
  dropInClientKey: clientKey,
  dropInEnvironment: environment,
  dropInSessionData: sessionData,
  dropInSessionEnabled: sessionEnabled,
  dropInSessionId: sessionId,
  duration,
  experiments,
  isStudentPromotion,
  isTrial,
  isTrialEligible,
  package_ids: packageIds,
  products,
  promoCampaign,
  promo_code_error: promoCodeError,
  promo_code_input_visibility: promoCodeInputVisibility,
  promo_code_submitting: promoCodeSubmitting,
  showPaypal,
  trialInfo,
  yearly_percent_off: yearlyPercentOff
}) => ({
  adyenClientPubkey,
  analyticsData,
  checkoutError,
  checkoutSubmitting,
  checkoutSuccess,
  checkoutSuccessRedirectPath,
  currency,
  clientKey,
  environment,
  sessionData,
  sessionEnabled,
  sessionId,
  duration,
  experiments,
  isStudentPromotion,
  isTrial,
  isTrialEligible,
  packageIds,
  products,
  promoCampaign,
  promoCodeError,
  promoCodeInputVisibility,
  promoCodeSubmitting,
  showPaypal,
  trialInfo,
  yearlyPercentOff
});

export default function summitCheckoutAppReducer(state = {}, action) {
  switch (action.type) {
    case types.SET_DURATION:
      return {
        ...state,
        duration: action.duration
      };
    //
    // Adyen checkout block
    //
    case types.ADYEN_PRODUCT_CHECKOUT_REQUEST:
      return {
        ...state,
        checkout_submitting: true
      };
    case types.ADYEN_PRODUCT_CHECKOUT_SUCCESS:
      return {
        ...state,
        checkout_success: true
      };
    case types.ADYEN_PRODUCT_CHECKOUT_FAILURE:
      return {
        ...state,
        checkout_submitting: false,
        checkout_error: true
      };
    case types.CLEAR_ADYEN_PRODUCT_CHECKOUT_ERROR:
      return {
        ...state,
        checkout_submitting: false,
        checkout_error: false
      };
    //
    // Promo code related
    //
    case types.CHECK_PROMO_CODE_REQUEST:
    case types.REMOVE_PROMO_CODE_REQUEST:
      return {
        ...state,
        promo_code_submitting: true
      };
    case types.CHECK_PROMO_CODE_SUCCESS:
    case types.REMOVE_PROMO_CODE_SUCCESS:
      return {
        ...state,
        promo_code_submitting: false,
        promo_code_error: false,
        promo_code_input_visibility: false,
        products: action.payload.products,
        duration: action.payload.products.default_selected
      };
    case types.CHECK_PROMO_CODE_FAILURE:
    case types.REMOVE_PROMO_CODE_FAILURE:
      return {
        ...state,
        promo_code_submitting: false,
        promo_code_error: true
      };
    case types.TOGGLE_PROMO_CODE_INPUT_VISIBILITY:
      return {
        ...state,
        promo_code_input_visibility: !state.promo_code_input_visibility
      };
    case types.APP_PROPS_REFRESH_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case types.APP_PROPS_ORGANIC_REFRESH_SUCCESS:
      return {
        ...state,
        ...action.payload,
        promo_code_input_visibility: true
      };
    default:
      return state;
  }
}
